import Button from "@material-ui/core/Button";
import React from "react";
import styled from "styled-components";
const StyledLightButton = styled(Button)`
  &.MuiButton-root {
    background: #fff;
    color: #0a0a29;
    font-size: 13px;
    line-height: 18px;
    border-radius: 4px;
    height: 36px;
    font-weight: 800;
    text-transform: none;
    &:hover {
      background: #fff;
    }
  }
`;

const DisabledButton = styled(Button)`
  &.MuiButton-root {
    background: #d1d1d1;
    color: #7f7f7f;
    font-size: 13px;
    line-height: 18px;
    border-radius: 4px;
    height: 36px;
    font-weight: 800;
    text-transform: none;
    &:hover {
      background: #d1d1d1;
    }
  }
`;

const LightButton = ({ children, hideIcon, disabled, ...rest }) => {
  return (
    <>
      {disabled ? (
        <DisabledButton disabled={disabled} {...rest}>
          {children}
        </DisabledButton>
      ) : (
        <StyledLightButton {...rest}>{children}</StyledLightButton>
      )}
    </>
  );
};

export default LightButton;
